import { usePassbook } from '@/shared/lib/passbook';
import { PageHeader } from '@/shared/components/page-header';
import { useDashboardSummary } from '../api/use-dashboard';
import { NativeDashboardPanel } from './native-dashboard-panel';
import { MetabaseEmbedPanel } from './metabase-embed-panel';

export function DashboardPage() {
  const { idPassbook, passbook } = usePassbook();
  const hasMetabase = Boolean(passbook.metabase?.length);
  const { data, isLoading } = useDashboardSummary(idPassbook, passbook, !hasMetabase);

  return (
    <>
      <PageHeader
        title="Painel"
        description={
          hasMetabase ? `${passbook.organizationName} — BI Avançado` : `${passbook.organizationName} — visão consolidada`
        }
      />

      {hasMetabase ? (
        <MetabaseEmbedPanel idPassbook={idPassbook} />
      ) : (
        <NativeDashboardPanel
          idPassbook={idPassbook}
          passbook={passbook}
          summary={data}
          isLoading={isLoading}
        />
      )}
    </>
  );
}
